import React from 'react';
import { CheckIcon, MountainIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach geology with confidence today'];
export function FinalCta() {
  return <section className="bg-stage-deep warm-glow py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jcd6sgl74af6">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1eejyni0c16c9">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-mossGlow" data-id="element-72" data-mp="1ec7m5kdcfo6l">
          <MountainIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o43kmwjcdgbc" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="223mh2s2sj37t">
          Created by earth science specialists, for educators worldwide
        </h2>

        <Countdown light className="mt-8" data-id="element-75" data-mp="n5ul3zmwvjfp" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-white p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n75mxtwsqh46">
          <p data-id="element-77" data-mp="x3s7ehl7n65o">
            <b className="block text-sm uppercase leading-tight text-ink" data-id="element-78" data-mp="x390rx10g46y">{productName}</b>
            <span className="text-sm text-muted" data-id="element-79" data-mp="122ln8gnyz990">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="1646w7qxdv3dx">
            <p className="text-sm text-muted" data-id="element-81" data-mp="1b31mtf1ldw8l">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1b1ytl0gsrhpi">{priceBefore}</span>
              <b className="text-base text-ink" data-id="element-83" data-mp="1fvb8givoca52">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1kt3ai5q19cmz">
              Get my collection now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-85" data-mp="1ttrqv72wfp31">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3qv6za7sgk24p">
              <CheckIcon className="h-4 w-4 text-mossGlow" aria-hidden="true" data-id="element-87" data-mp="3lwdoin4k2p88" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}